import { Box, Button, PopupDialog } from "designSystem/index";
import React, { useState } from "react";

export default () => {
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);
	const onButton = () => setOpen(true);

	return (
		<Box>
			<Button design="primary" onClick={onButton}>
				Popup Dialog with Custom Content
			</Button>
			<PopupDialog
				onClose={onClose}
				open={open}
				title="Dialog Title"
			>
				{{
					main: (
						<Box>Custom Content</Box>
					),
				}}
			</PopupDialog>
		</Box>
	);
};